export default "__VITE_ASSET__CewiQCh$__"